import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var UserSquare = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "user-square",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 21.8174C4.6026 22 5.4165 22 6.8 22h10.4c1.3835 0 2.1974 0 2.8-.1826m-16 0a2.1805 2.1805 0 0 1-.362-.1444 2.9997 2.9997 0 0 1-1.311-1.311C2 19.7202 2 18.8802 2 17.2V6.8c0-1.6802 0-2.5202.327-3.162a3 3 0 0 1 1.311-1.311C4.2798 2 5.1198 2 6.8 2h10.4c1.6802 0 2.5202 0 3.162.327a2.9997 2.9997 0 0 1 1.311 1.311C22 4.2798 22 5.1198 22 6.8v10.4c0 1.6802 0 2.5202-.327 3.162a2.9994 2.9994 0 0 1-1.311 1.311 2.1806 2.1806 0 0 1-.362.1444m-16 0c.0004-.8093.0052-1.2375.0769-1.5978a4 4 0 0 1 3.1427-3.1427C7.606 17 8.0706 17 9 17h6c.9293 0 1.394 0 1.7804.0769a4 4 0 0 1 3.1427 3.1427c.0717.3603.0765.7885.0769 1.5978M16 9.5c0 2.2091-1.7909 4-4 4-2.2091 0-4-1.7909-4-4 0-2.2091 1.7909-4 4-4 2.2091 0 4 1.7909 4 4Z"
    })
  }));
};
export default UserSquare;